// extracted by mini-css-extract-plugin
module.exports = {"certificate-wrapper":"CertifiedTrust_certificate-wrapper__vmRpg","certificate":"CertifiedTrust_certificate__Cb_6G","image-wrapper":"CertifiedTrust_image-wrapper__PulQd"};